import { createContext } from 'react';

export type SendOnboardingEmailCtx = {
  showSendOnboardingEmailConfirmAlert: boolean;
  showSendOnboardingEmailSuccessAlert: boolean;
  showSendOnboardingEmailErrorAlert: boolean;
  sendOnboardingEmailError: string;
};

const SendOnboardingEmailContext = createContext<SendOnboardingEmailCtx>({
  showSendOnboardingEmailConfirmAlert: false,
  showSendOnboardingEmailSuccessAlert: false,
  showSendOnboardingEmailErrorAlert: false,
  sendOnboardingEmailError: ''
});

export default SendOnboardingEmailContext;
